<script>
  import Image from '@/components/Image/Image'

  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      url: {
        type: String,
        required: true
      },
      external: {
        type: Boolean,
        default: false
      },
      behaviour: {
        type: String
      },
      eyeCatcher: {
        type: String
      },
      image: {
        type: Object
      }
    },
    components: {
      'hp-image': Image
    }
  }
</script>

<template>
  <span>
    <a :href="url" :target="external ? '_blank' : false" :rel="behaviour ? behaviour : false">
      <hp-image v-if="image" v-bind="image"></hp-image>
      {{ title }}
    </a>
    <sup v-if="eyeCatcher">{{ eyeCatcher }}</sup>
  </span>
</template>
